import { RouteConfig } from "vue-router";

const tipoDocumentos: RouteConfig = {
  path: "/tipoDocumentos",
  name: "tipoDocumentos",
  component: () => import(/* webpackChunkName: "tipo-documentos" */ "@/views/TipoDocumentos.vue"),
};

export default tipoDocumentos;
